export const locationsData = [
    { 
        locationId: 1922,
        type: "SECCION 3",
        position: "top",
        shape: "poly",
        color: "31af67",
        coords: "2850.34 5169.06 2979.53 5112.64 2939.45 5062.34 2906.77 5028.64 2871.02 4989.32 2811.02 5043.45 2814.34 5050.85 2815.36 5056.21 2813.32 5063.36 2811.02 5067.7 2822 5089.66 2850.34 5169.06",
    },
    {
        locationId: 2236,
        type: "SECCION 3",
        position: "top",
        shape: "poly",
        color: "31af67",
        coords: "2748.72 4824.64 2737.23 4821.57 2709.4 4810.6 2648.89 4888.72 2683.11 4914.26 2748.72 4824.64",
    },
    { 
        locationId: 12376,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",
        coords: "4696.3 4656.98 4613.91 4573.23 4572.04 4616.81 4455.62 4820.72 4545.83 4785.66 4563.53 4773.06 4594.85 4751.62 4696.3 4656.98",
    }, 
    { 
        locationId: 12377,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",
        coords: "4382.09 4874.68 4327.87 4798.34 4484.89 4669.15 4517.06 4656.13 4546.94 4637.23 4572.98 4615.79 4456.55 4820.04 4382.09 4874.6",
    },
    {
        locationId: 112378,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "4382 4874.68 4340.13 4815.45 4256.38 4905.06 4196.64 4945.91 4200.98 4952.04 4203.02 4960.98 4201.23 4971.19 4194.6 4979.62 4186.17 4985.23 4173.4 4985.23 4180.55 5004.89 4244.38 4978.09 4382 4874.68",
    },
    {
        locationId: 112379,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "4339.87 4814.77 4327.79 4797.91 4200.13 4888.81 4178.85 4901.23 4155.53 4910.26 4138.17 4914.68 4127.45 4916.38 4136.47 4985.49 4156.72 4970.85 4155.87 4963.87 4157.06 4953.49 4160.47 4947.36 4166.43 4942.43 4173.57 4939.53 4181.91 4938.51 4189.57 4941.06 4196.72 4946.51 4253.06 4907.7 4339.87 4814.77",
    },
    {
        locationId: 112380,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "4127.26 4916.43 4110.72 4918.09 4095.21 4918.09 4083.79 4917.7 4074.79 4916.43 4070.09 5005.74 4086.43 5004.72 4104.64 4999.96 4121.32 4993.66 4137.15 4985.83 4127.26 4916.43",
    },
    
    {
        locationId: 112381,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "4074.68 4916.72 4053.23 4912.98 4030.43 4908.21 4004.55 4994.51 4020.21 4999.11 4040.81 5003.36 4058.34 5005.4 4070.77 5005.4 4074.68 4916.72",
    },
    {
        locationId: 112382,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "4030.6 4908.55 4002.68 4901.23 3982.6 4892.72 3942.26 4962.17 3961.49 4975.62 3987.19 4987.87 4005.06 4994.34 4030.6 4908.55",
    },
    {
        locationId: 112381,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3983.11 4893.23 3922.34 4853.06 3888.98 4902.6 3904.47 4920.64 3923.36 4943.62 3942.43 4962.51 3983.11 4893.23",
    },
    {
        locationId: 11484,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3922.68 4853.06 3888.98 4903.11 3861.4 4875.36 3838.26 4862.43 3831.96 4859.02 3855.45 4808.13 3922.68 4853.06",
    },
    {
        locationId: 11483,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3831.79 4858.68 3855.45 4808.3 3834.85 4793.83 3811.19 4784.3 3792.13 4780.55 3774.09 4780.55 3776.3 4850 3795.02 4849.83 3811.7 4852.38 3831.79 4858.68",
    },
    {//g4-24
        locationId: 11482,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3776.77 4849.66 3774.6 4779.45 3751.49 4780.98 3726.72 4786.09 3699.4 4793.49 3666.85 4813.53 3732.98 4848 3741.66 4842.64 3750.34 4840.6 3758.26 4842.38 3765.28 4846.21 3769.23 4849.66 3776.77 4849.66",
    },
    {//g4-25
        locationId: 11492,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3734 4848.64 3667.62 4813.02 3659.96 4818.89 3655.23 4825.4 3652.43 4831.66 3651.02 4836.64 3652.04 4924.98 3730.81 4876.98 3727.49 4870.47 3726.6 4862.04 3728.38 4855.53 3731.32 4851.19 3734 4848.64",
    },
    {//g4-26
        locationId: 11492,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3730.94 4876.21 3652.3 4924.72 3652.3 4963.53 3677.83 4973.36 3700.55 4978.98 3722.38 4981.02 3747.28 4888.21 3739.74 4885.79 3734.26 4881.45 3731.06 4877.49 3730.94 4876.21",
    },
    {//g4-27
        locationId: 11491,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3722.38 4981.02 3746.38 4981.02 3760.94 4979.23 3814.04 4966.72 3773.96 4874.43 3770.64 4879.15 3765.02 4883.62 3759.15 4886.81 3750.47 4887.7 3746.89 4887.7 3722.38 4981.02",
    },
    {//g4-28
        locationId: 11489,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3888.21 4971.19 3916.3 5074.85 4070.51 5034.77 4160.13 5011.28 4181.32 5004.13 4173.15 4984.21 4169.57 4986.77 4156.04 4997.49 4144.81 5004.38 4132.81 5011.28 4122.09 5016.38 4107.79 5020.72 4093.23 5024.81 4076.38 5027.11 4053.4 5026.85 4028.89 5023.02 4005.91 5017.66 3971.19 5003.87 3948.21 4991.36 3930.34 4978.85 3914 4971.19 3902.77 4969.66 3888.21 4971.19",
    },
    {//g4-29
        locationId: 11488,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3888.47 4971.53 3838.09 4983.28 3865.83 5088.81 3916.04 5075.19 3888.47 4971.53",
    },
    {//g4-30
        locationId: 11487,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3838.6 4983.28 3795.36 4993.49 3822.77 5099.7 3865.83 5088.47 3838.6 4983.28",
    },
    {//g4-31
        locationId: 11486,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3795.7 4993.15 3754.68 5002 3771.7 5112.64 3823.28 5100.04 3795.7 4993.15",
    },
    {//g4-32
        locationId: 11485,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3754.51 5000.98 3718.09 5000.98 3705.49 5000.98 3712.64 5128.64 3772.21 5112.98 3754.51 5000.98",
    },
    {//g4-33
        locationId: 11481,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3705.49 5000.64 3686.77 4997.91 3664.98 4991.28 3653.23 4987.36 3654.77 5137.83 3677.91 5137.83 3712.64 5128.47 3705.49 5000.64",
    },
    {//g5-20
        locationId: 11503,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3616.04 5138.17 3616.04 5127.7 3607.11 5119.79 3603.79 5112.38 3605.83 5096.81 3614 5087.62 3614.26 5068.72 3537.91 5067.45 3536.38 5146.09 3547.11 5138.43 3550.94 5131.53 3616.04 5138.17",
    },
    {//g5-19
        locationId: 11502,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3537.66 5067.45 3614.26 5068.47 3614.26 5015.11 3614.26 5005.15 3537.66 5004.13 3537.66 5067.45",
    },
    {//g5-18
        locationId: 11501,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3538.94 5003.36 3614.77 5004.64 3612.98 4901.49 3610.43 4899.7 3579.53 4921.66 3559.11 4940.55 3538.94 4964.3 3538.94 5003.36",
    },
    {//g5-17
        locationId: 11504,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3459.02 5160.13 3536.64 5148.64 3539.45 4963.53 3516.72 4994.17 3494 5032.72 3477.66 5072.55 3467.7 5103.96 3462.09 5131.28 3459.02 5160.13",
    },
    {//g5-16
        locationId: 11499,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3357.4 5175.19 3437.32 5164.21 3444.47 5108.3 3363.79 5090.94 3359.96 5109.83 3357.4 5129.74 3357.4 5175.19",
    },
    {//g5-15
        locationId: 11418,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3364.04 5090.68 3444.72 5108.55 3450.51 5085.06 3462.77 5050.51 3383.45 5016.3 3372.04 5054.43 3364.04 5090.68",
    },
    {//g5-14
        locationId: 11497,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3383.96 5016.81 3463.28 5050.17 3478.6 5016.81 3490.17 4996.72 3413.57 4952.3 3397.4 4983.62 3383.96 5016.81",
    },
    {//g5-13
        locationId: 11496,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3413.4 4953.32 3490 4996.72 3528.81 4943.62 3453.23 4896.64 3434.17 4920.81 3413.4 4953.32",
    },
    {//g5-12
        locationId: 11495,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3615.96 4820.38 3584.47 4799.62 3556.55 4868.38 3490.85 4920.3 3528.47 4943.45 3570 4903.45 3599.11 4883.19 3599.28 4871.53 3605.06 4864.64 3612.55 4858.85 3611.7 4831.28 3615.96 4820.38",
    },
    {//g5-11
        locationId: 11494,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3583.79 4799.96 3594.34 4783.11 3555.02 4756.21 3557.57 4765.91 3555.02 4773.91 3550.94 4781.57 3545.83 4785.66 3538.68 4788.89 3531.02 4788.72 3526.43 4820.21 3525.4 4844.89 3525.4 4860.04 3498 4860.04 3490.17 4854.94 3453.4 4896.13 3490.68 4919.96 3556.55 4869.4 3583.79 4799.96",
    },
    {//g5-10
        locationId: 11493,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3583.62 4800.13 3615.62 4819.87 3625.66 4800.13 3636.55 4787.87 3651.7 4775.11 3671.96 4763.53 3699.19 4751.79 3682 4696.64 3667.87 4704.64 3650.85 4719.45 3638.43 4730.51 3628.55 4741.4 3617.66 4753.32 3607.45 4765.06 3595.02 4781.74 3583.62 4800.13",
    },
    /* {//g5-9
        locationId: 11492,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "",
    }, */
    {//g3-5
        locationId: 11475,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3506.26 4643.87 3574.17 4699.28 3598.68 4669.15 3531.53 4611.45 3506.26 4643.87",
    },
    {//g3-6
        locationId: 11476,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3539.19 4742.94 3574.68 4699.53 3539.19 4671.7 3487.11 4738.09 3511.62 4758.77 3515.19 4750.34 3523.62 4745.74 3530.89 4742.68 3539.19 4742.94",
    },
    {//g3-7
        locationId: 11477,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3487.36 4737.06 3540.72 4670.94 3505.23 4644.13 3477.66 4678.34 3479.19 4686.26 3477.66 4694.94 3475.11 4701.57 3468.21 4706.43 3460.81 4711.79 3451.11 4710.51 3487.36 4737.06",
    },
    {//g3-8
        locationId: 11478,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3345.91 4864.21 3432.72 4923.19 3458.77 4888.98 3490.43 4855.28 3375.02 4801.66 3345.91 4864.21",
    },
    {//g3-9
        locationId: 11479,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3306.34 4953.06 3394.68 4991.62 3414.6 4951.02 3433.23 4922.68 3346.17 4863.45 3321.66 4916.55 3306.34 4953.06",
    },
    {//g3-10
        locationId: 11473,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3282.85 5056.47 3367.11 5074.85 3382.68 5018.17 3394.43 4990.85 3306.6 4951.79 3295.62 4982.68 3290.77 5002.09 3285.91 5029.4 3282.85 5056.47",
    },
    {//g3-11
        locationId: 11474,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3279.53 5187.19 3357.66 5175.19 3357.66 5142.26 3359.7 5112.13 3367.62 5074.85 3282.09 5055.7 3279.53 5085.06 3287.7 5090.17 3294.34 5102.17 3293.83 5110.6 3289.49 5119.28 3285.4 5123.36 3276.21 5128.98 3272.38 5129.74 3279.53 5187.19",
    },
    {//b11-13
        locationId: 11456,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2897.57 4777.15 2891.32 4797.06 2885.96 4817.23 2877.4 4836.51 3047.83 4998.26 3065.45 4904.55 2897.57 4777.15",
    },
    {//b9-10
        locationId: 11465,
        type: "SECCION 7GB",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2863.79 4810.85 2881.49 4755.02 2894.09 4740.04 2931.53 4714.85 2872.3 4521.49 2863.79 4539.87 2850.85 4554.17 2835.19 4568.13 2821.23 4574.6 2795.36 4575.62 2842.34 4744.13 2863.79 4810.85",
    },
    //h
    {//H17
        locationId: 10193,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2547.53 5378.94 2560.3 5417.49 2649.15 5371.02 2635.62 5332.72 2547.53 5378.94",
    },//h18
    {
        locationId: 10194,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2649.49 5370.51 2560.3 5417.83 2571.36 5455.62 2662.09 5408.98 2649.49 5370.51",
    },
    {//h31
        locationId: 10207,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2841.53 5318.55 2750.64 5340.64 2749.49 5350.47 2749.49 5360.17 2754.21 5374.47 2762.77 5394.89 2854.94 5352.64 2841.53 5318.55",
    },
    {//h32
        locationId: 10203,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2874.98 5389.91 2791.49 5442.64 2776.43 5420.04 2762.77 5394.26 2855.06 5352.26 2863.62 5369.87 2874.98 5389.91",
    },
    {//h33
        locationId: 10208,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2791.36 5442.51 2807.57 5463.06 2828.89 5484 2899.74 5422.47 2888.13 5408.17 2874.72 5390.04 2791.36 5442.51",
    },
    {//h34
        locationId: 10210,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2829.02 5484.26 2842.04 5494.98 2853.91 5503.4 2874.09 5516.3 2929.23 5452.6 2913.4 5438.3 2899.49 5422.21 2829.02 5484.26",
    },
    {//h35
        locationId: 10211,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2967.53 5485.66 2931.28 5541.45 2906.26 5532.38 2888.38 5524.21 2873.83 5516.68 2929.23 5453.11 2946.21 5468.3 2967.53 5485.66",
    },
    {//h38
        locationId: 10214,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3065.19 5455.66 3045.91 5440.21 3028.68 5423.36 2969.83 5478.64 2987.57 5491.53 3006.72 5502.89 3023.96 5511.19 3065.19 5455.66",
    },
    {//h39
        locationId: 10215,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3028.68 5423.62 2969.7 5478.51 2946.85 5461.28 2924.51 5440.98 2997.4 5384.68 3009.15 5400.51 3028.68 5423.62",
    },
    {//h40
        locationId: 10216,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2997.66 5385.06 2987.19 5369.62 2976.09 5347.28 2878.3 5383.91 2896.3 5409.06 2911.36 5427.06 2924.77 5440.6 2997.66 5385.06",
    },
    {//h44
        locationId: 10220,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3010.55 5364.13 3089.7 5321.74 3074.64 5282.17 2990.26 5297.49 2988.6 5308.09 2988.6 5318.55 2991.02 5328.26 3001.23 5348.68 3010.55 5364.13",
    },
    {//h49
        locationId: 10225,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3296.51 5390.68 3273.15 5393.62 3262.81 5394.51 3246.21 5393.36 3253.49 5474.04 3311.32 5455.53 3296.51 5390.6",
    },
    {//h52
        locationId: 10228,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3477.66 5293.53 3413.57 5286.89 3413.57 5301.19 3410 5313.06 3402.98 5327.23 3398.64 5333.74 3450.21 5371.02 3460.94 5353.79 3470.13 5334.64 3475.62 5317.02 3477.66 5306.17 3477.66 5293.53",
    },
    {//h53
        locationId: 10229,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3591.28 5235.32 3494.77 5259.32 3498.47 5273.87 3499.23 5286.89 3499.49 5299.28 3598.68 5305.02 3598.68 5280.26 3597.53 5265.19 3594.98 5249.49 3591.28 5235.32",
    },
    {//h54
        locationId: 10230,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "3598.94 5305.66 3499.36 5298.89 3498.34 5313.7 3496.68 5324.94 3493.49 5338.09 3586.43 5371.53 3592.3 5354.3 3596.26 5337.45 3598.17 5320.85 3598.94 5305.66",
    },
    {//h70
        locationId: 10246,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2958.51 5589.83 2903.02 5607.28 2960.3 5693.66 2987.87 5684.72 2958.51 5589.83",
    },
    {//h81
        locationId: 10257,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2564.38 5496.13 2478.09 5545.66 2465.06 5519.36 2461.74 5509.15 2549.57 5458.34 2556.21 5476.98 2564.38 5496.1",
    },
    {//h82
        locationId: 10258,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2550.09 5458.6 2461.49 5509.66 2450 5470.09 2538.34 5418.77 2550.09 5458.6",
    },
    {//h83
        locationId: 10259,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2524.81 5381.23 2437.23 5431.79 2449.49 5470.85 2538.09 5419.53 2524.81 5381.23",
    },
    {//h84
        locationId: 10260,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2436.98 5431.53 2524.55 5380.98 2508.98 5344.21 2421.91 5394.26 2436.98 5431.53",
    },
    {//h85
        locationId: 10261,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2509.23 5344.47 2422.43 5393.74 2405.32 5357.49 2491.62 5308.72 2500.81 5326.34 2509.23 5344.47",
    },
    {//h86
        locationId: 10262,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2492.38 5307.96 2405.83 5358 2387.19 5322.26 2472.98 5273.23 2492.38 5307.96",
    },
    {//h87
        locationId: 10263,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2472.98 5272.98 2387.19 5322.51 2364.72 5289.57 2451.02 5239.79 2461.49 5253.83 2472.98 5272.98",
    },
    {//h88
        locationId: 10264,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2364.72 5289.83 2451.28 5239.79 2435.7 5219.11 2425.74 5208.38 2336.89 5258.68 2352.21 5275.28 2364.72 5289.8",
    },
    {//h89
        locationId: 10265,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2425.74 5208.38 2336.89 5258.94 2314.17 5240.04 2306.51 5231.36 2395.87 5179.53 2412.21 5194.09 2425.74 5208.38",
    },
    {//h90
        locationId: 10266,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2307.02 5231.36 2396.64 5179.02 2368.04 5149.66 2280.98 5200.21 2307.02 5231.36",
    },
    {//h91
        locationId: 10267,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2280.72 5200.21 2368.04 5149.91 2353.23 5130 2344.55 5117.23 2258.77 5166.51 2268.21 5183.11 2280.72 5200.21",
    },
    {//h92
        locationId: 10268,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2343.96 5117.23 2324.72 5082.51 2238.77 5132.21 2258.17 5167.11 2343.96 5117.23",
    },
    {//h93
        locationId: 10269,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2238.6 5132.38 2325.06 5082.85 2307.87 5053.06 2298.51 5039.62 2217.83 5098.51 2228.21 5114.34 2238.6 5132.38",
    },
    {//h94
        locationId: 10270,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2217.83 5099.02 2298.85 5039.79 2280.98 5017.15 2266.68 5002.51 2191.11 5068.04 2205.06 5082.68 2217.83 5099.02",
    },
    {//h95
        locationId: 10271,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2191.28 5067.7 2266.68 5002.68 2248.98 4985.66 2231.11 4971.87 2157.4 5038.77 2167.62 5048.81 2191.28 5067.7",
    },
    {//h96
        locationId: 10272,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2157.06 5039.11 2231.62 4971.36 2214.77 4955.53 2203.02 4943.28 2122.17 5001.32 2132.72 5015.62 2157.06 5039.11",
    },
    {//h98
        locationId: 10274,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2068.55 4916.89 2078.26 4938.17 2088.81 4956.21 2177.32 4908.72 2162.17 4884.55 2159.79 4879.11 2068.55 4916.89",
    },
    {//h100
        locationId: 10276,
        type: "SECCION 8H",

        position: "top",
        shape: "poly",
        color: "31af67",

        coords: "2038.77 4822.09 2043.02 4843.87 2050.85 4872.13 2146.17 4844.21 2140.38 4821.06 2136.64 4805.91 2038.77 4822.09",
    },
    
];